<app-auth-shell>
  @if (sentTo) {
    <div class="af-center">
      <span class="af-badge" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 6.5l8.5 6.5 8.5-6.5"/></svg>
      </span>
      <div class="af-head">
        <h1>Check your inbox</h1>
        <p>If <strong>{{ sentTo }}</strong> has a WorldTumbler account, we've sent it a link to choose a new password. The link works once, for 1 hour.</p>
      </div>
      <div class="af-stack">
        <a class="af-btn af-btn--primary" routerLink="/login" [queryParams]="{ email: sentTo }">Back to sign in</a>
        <p class="af-hint">Nothing arrived? Check your spam folder, or <button type="button" class="af-link af-link--small" (click)="again()">try another email</button>.</p>
      </div>
    </div>
  } @else {
    <div class="af-head">
      <h1>Forgot your password?</h1>
      <p>Enter your account's email and we'll send you a link to choose a new one.</p>
    </div>

    @if (error) {
      <div class="af-alert af-alert--error" role="alert"><p>{{ error }}</p></div>
    }

    <form class="af-form" (ngSubmit)="submit()" novalidate>
      <div class="af-field">
        <label class="af-label" for="fp-email">Email</label>
        <input id="fp-email" class="af-input" type="email" [formControl]="email" autocomplete="email" inputmode="email"
          autocapitalize="off" spellcheck="false" [class.is-invalid]="email.invalid && email.touched" autofocus />
        @if (email.invalid && email.touched) {
          <p class="af-error">Enter a valid email address.</p>
        }
      </div>
      <button type="submit" class="af-btn af-btn--primary" [disabled]="busy">
        @if (busy) { <span class="af-spinner" aria-hidden="true"></span> Sending… } @else { Send reset link }
      </button>
    </form>

    <p class="af-foot">Remembered it? <a class="af-link" routerLink="/login">Sign in</a></p>
  }
</app-auth-shell>
